export const SORT_DIRECTION = {
  DESC: 'DESC',
  ASC: 'ASC'
}

export const FILE_TYPES = {
  CSV: ['text/csv', 'application/vnd.ms-excel']
}

export const DEFAULTS = {
  PAGE_NUM: 1,
  PAGE_SIZE: 10,
  SORT_DIRECTION: SORT_DIRECTION.DESC
}

export const TRANSACTION_SORT_BY = ['id', 'createdAt', 'updatedAt', 'amount', 'remaining']
export const JOB_SORT_BY = ['id', 'status', 'createdAt', 'billingStartedAt', 'lastPaymentAt',
  'expiresOn', 'jobLocationType', 'position']

export const JOB_STATUSES = {
  APPROVED: 'Approved',
  DELETED: 'Deleted',
  EXPIRED: 'Expired',
  UNPAID: 'Unpaid'
}

export const JOB_LOCATION_TYPE = {
  LOCAL: 'Local',
  REGIONAL: 'Regional',
  OVER_THE_ROAD: 'Over The Road',
  TEAM_DRIVING: 'Team Driving'
}

export const PAY_STRUCTURE = {
  HOURLY: 'Hourly',
  MILEAGE: 'Mileage',
  PERCENTAGE_OF_LOAD: 'PercentageOfLoad'
}

export const JOB_REPORT_STATUSES = {
  PENDING: 'Pending',
  RESOLVED: 'Resolved'
}

export const RECRUITER_STATUSES = {
  PENDING: 'Pending',
  REJECTED: 'Rejected',
  APPROVED: 'Approved'
}

export const JOBS_BOARD_PRIVACY_TYPES = {
  OPEN: 'Open',
  SEMI_PRIVATE: 'Semi-private',
  PRIVATE: 'Private'
}

export const JOBS_BOARD_TYPES = {
  BOTH: 'Both',
  EXPERIENCED: 'Experienced',
  ENTRY: 'Entry'
}

export const RECEIVE_NOTIFICATION_TYPE = {
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  EVERY_TO_WEEKS: 'Every Two Weeks'
}

export const PRIOR_EXPERIENCE_NEEDED = {
  GRADUATE: 'Graduate from truck driving school',
  MORE_THAN_SCHOOL: 'More than truck driving school'
}

export const SCHOOLS_TYPE = {
  CLAIMED: 'Claimed',
  UNCLAIMED: 'Unclaimed'
}

export const APPLICATIONS_TYPE = {
  APPROVED: 'Approved',
  DECLINED: 'Declined',
  PENDING: 'Pending'
}


export const VALIDATION = {
  AVATAR_MAX_SIZE: 10 * 1000000, // 10 mb
  MESSAGES: {
    REQUIRED: 'Required',
    ZIP: 'Must be a valid zip',
    SSN: 'Must be a valid social security number',
    DATE: 'Must be a valid date',
    SUB_DOMAIN: 'Must be a valid subdomain',
    DATE_PERIOD: 'Must be a valid date period',
    COLOR: 'Color hex invalid',
    STATE: 'State is invalid',
    EMAIL: 'Email is invalid',
    INTEGER: 'Must be an integer',
    POSITIVE: 'Must be a positive number',
    NUMBER: 'Must contain only digits',
    MUST_BE_NULL: 'Must be null',
    MUST_ADD_UP_TO_100_PERCENT: (string) => `Must add up to 100% with "${string}"`,
    MUST_START_WITH: ({ string }) => `Must start with "${string}"`,
    PASSWORD: 'Incorrect password format. Must be lowercase, uppercase, number, special character and at least 8 characters.',
    SIMPLE_PASSWORD: 'Incorrect password format. Must be at least 3 characters.',
    PHONE: 'Enter phone number in ***-***-**** format',
    SOCIAL_SECURITY_NUMBER: 'Enter social security number in ***-**-**** format',
    NON_EMPTY_ARRAY: 'Choose at least one option',
    IMAGE_MIME: 'File type must be an image',
    MIN: (number) => `Must not be less than ${number}`,
    MAX: (number) => `Must not be more than ${number}`,
    MIN_LENGTH: (minValue) => `Minimal length is ${minValue} characters`,
    PRICE_INPUT_RANGE: 'The second rate must not be less than the first one',
    PAYMENT_METHOD: 'A method of payment is needed.',
    URL: 'Must be a valid URL',
    MUST_BE_DIVISIBLE_BY_FIVE_AND_CAN_NOT_BE_IN_RANGE: 'Must be divisible by five and can not be in range 91-99',
    MUST_BE_GREATER_OR_EQUAL_FIVE: 'Must be greater than or equal to $5'
  },
  REGEXP: {
    // minimum 8 chars, must include 1 lowercase letter, 1 uppercase letter, 1 number and 1 special char
    PASSWORD: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).{8,}$/,
    // minimum 3 chars
    SIMPLE_PASSWORD: /^.{3,}$/,
    COLOR: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
    PHONE: /^\d{3}-\d{3}-\d{4}$/,
    SOCIAL_SECURITY_NUMBER: /^\d{3}-\d{2}-\d{4}$/,
    ZIP: /^\d{5}(-\d{4})?$/,
    IMAGE_MIME: /image\/(gif|jpe?g|tiff?|png|webp|bmp)$/,
    ONLY_DIGITS: /^[0-9]*$/,
    // subdomain string, should be from 1 to 63 chars: alphanumerical + "-" (but cannot start or end with it).
    SUB_DOMAIN: /^(?!www\b)(^[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])$)/,
    SSN: /^(?!0{3})(?!6{3})[0-8]\d{2}-(?!0{2})\d{2}-(?!0{4})\d{4}$/
  }
}

export const ERROR_NAMES = {
  VALIDATION: 'ValidationError',
  INTERNAL: 'InternalError',
  UNAUTHORIZED: 'UnauthorizedError',
  FORBIDDEN: 'ForbiddenError',
  NOT_FOUND: 'NotFoundError',
  YUP_VALIDATION: 'YupValidationError',
  CSV_VALIDATION: 'CsvValidationError',
  SEQUELIZE_UNIQUE_CONSTRAINT: 'SequelizeUniqueConstraintError',
  DO_SPACES: 'DigitalOceanSpacesError',
  SEND_GRID: 'SendGridError',
  STRIPE: 'StripeError'
}

export const STATUS_CODES = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  VALIDATION: 400,
  INTERNAL: 500,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  PAYMENT_REQUIRED: 402
}

export const ERROR_CODES = {
  NOT_VALID_TOKEN: 10001,
  NOT_VALID_CREDENTIALS: 10002,
  DO_SPACES_NO_SUCH_KEY: 20001,
  SEQUELIZE_UNIQUE_CONSTRAINT: 30001
}

export const ACTIONS = {
  APPROVE_JOB: 'approve_job',
  REJECT_JOB: 'reject_job',
  APPROVE_ALL_COMPANY_JOBS: 'approve_all_company_jobs',
  APPROVE_SCHOOL_CLAIM: 'approve_school_claim',
  REJECT_SCHOOL_CLAIM: 'reject_school_claim',
  APPROVE_SCHOOL_SIGN_UP: 'approve_school_sign_up',
  REJECT_SCHOOL_SIGN_UP: 'reject_school_sign_up'
}

export const NOTIFICATION_ABOUT_NEW_BOARD = {
  NO_NOTIFICATIONS: 'No notifications for new boards',
  WITHIN_100_MILES: 'Within 100 miles of currently posted jobs',
  WITHIN_250_MILES: 'Within 250 miles of currently posted jobs',
  NATIONALY: 'Nationally'
}
